import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Outlet } from 'react-router-dom';
import LeftMenu from './LeftMenu';
import './Dashboard.css';

import {
  LEFT_MENU_ADMINISTRATION,
  LEFT_MENU_ROLE_AND_PERMISSION,
  LEFT_MENU_USER_MANAGEMENT,
  LEFT_MENU_MANAGE_RESOURCE,
  LEFT_MENU_MANAGE_PACKAGE,
  LEFT_MENU_MANAGE_PRODUCT,
  LEFT_MENU_MANAGE_CAMPAIGN,
  LEFT_MENU_ORDER_MANAGEMENT,
  LEFT_MENU_VIEW_ORDER,
  LEFT_MENU_VIEW_SALES,
  LEFT_MENU_VIEW_ESIM,
  ROUTES
} from '../../utils/constant';

function Dashboard() {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedMenu, setSelectedMenu] = useState(null);

  const menuToRouteMap = {
    [LEFT_MENU_USER_MANAGEMENT]: ROUTES.USER_MANAGEMENT,
    [LEFT_MENU_ROLE_AND_PERMISSION]: ROUTES.ROLE_AND_PERMISSION,
    [LEFT_MENU_MANAGE_PACKAGE]: ROUTES.MANAGE_PACKAGE,
    [LEFT_MENU_MANAGE_PRODUCT]: ROUTES.MANAGE_PRODUCT,
    [LEFT_MENU_MANAGE_CAMPAIGN]: ROUTES.MANAGE_CAMPAIGN,
    [LEFT_MENU_VIEW_ORDER]: ROUTES.VIEW_ORDER,
    [LEFT_MENU_VIEW_SALES]: ROUTES.VIEW_SALES,
    [LEFT_MENU_VIEW_ESIM]: ROUTES.VIEW_ESIM,
  };

  const routeToMenuMap = Object.fromEntries(
    Object.entries(menuToRouteMap).map(([k, v]) => [v, k])
  );

  const getMenuFromRoute = (currentRoute) => {
    if (currentRoute.includes('/user-management/')) {
      return LEFT_MENU_USER_MANAGEMENT;
    }

    if (currentRoute.startsWith('/dashboard/role-and-permission')) {
      return LEFT_MENU_ROLE_AND_PERMISSION;
    }

    if (currentRoute.startsWith('/dashboard/manage-package')) {
      return LEFT_MENU_MANAGE_PACKAGE;
    }

    if (currentRoute.startsWith('/dashboard/manage-product')) {
      return LEFT_MENU_MANAGE_PRODUCT;
    }

    if (currentRoute.startsWith('/dashboard/manage-campaign')) {
      return LEFT_MENU_MANAGE_CAMPAIGN;
    }
    return routeToMenuMap[currentRoute] || null;
  };

  const handleMenuSelect = (menuTitle) => {
    setSelectedMenu(menuTitle);
    const route = menuToRouteMap[menuTitle] || ROUTES.DASHBOARD_HOME;
    navigate(route);
  };

  useEffect(() => {
    const currentRoute = location.pathname;
    const menu = getMenuFromRoute(currentRoute);
    setSelectedMenu(menu);
  }, [location.pathname]);

  const menuItems = [
    LEFT_MENU_ADMINISTRATION,
    LEFT_MENU_MANAGE_RESOURCE,
    LEFT_MENU_ORDER_MANAGEMENT
  ];

  return (
    <div className="dashboard-container">
      <div className="sidebar">
        {menuItems.map((item) => (
          <LeftMenu
            key={item}
            title={item}
            onSelect={handleMenuSelect}
            activeMenuItem={selectedMenu}
          />
        ))}
      </div>
      <div className="content">
        <Outlet />
      </div>
    </div>
  );
}

export default Dashboard;